import React from 'react';
import '../Footer/footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-bottom">
        <p>&copy; 2025 PT. Mars Acme Perkasa. All Rights Reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
